import ErrorStackParser from 'error-stack-parser';
// @ts-ignore
import stringify from 'json-stringify-safe';

type StackFrame = ErrorStackParser.StackFrame;

export function isErrorInstance(error: Error): boolean {
  const protoName = Object.getPrototypeOf(error).name;
  return (
    error &&
    (error instanceof Error ||
      ['Error', 'TypeError', 'SyntaxError', 'ReferenceError', 'RangeError'].indexOf(protoName) >= 0)
  );
}

export function getStackList(error: Error): string[] {
  try {
    if (!error) return [];
    if (!isErrorInstance(error)) return [stringify(error)];
    if (!error.stack) return [];
    return error.stack.split('\n');
  } catch (e) {
    console.error('获取错误堆栈出错', e);
    return [];
  }
}

export function getStackFrame(error: Error): StackFrame {
  try {
    const stackList: StackFrame[] = ErrorStackParser.parse(error);
    return stackList[0];
  } catch (e) {
    console.error('解析错误堆栈出错', e);
    return {} as StackFrame; // 解析出错就不上报堆栈信息
  }
}

export function getStackFrameList(error: Error) {
  if (!isErrorInstance(error)) return [];

  try {
    const stackList: StackFrame[] = ErrorStackParser.parse(error);
    return stackList.map((item) => ({
      filename: item.fileName,
      function: item.functionName,
      lineno: item.lineNumber,
      colno: item.columnNumber,
      in_app: true,
    }));
  } catch (e) {
    console.error('解析错误堆栈出错', e);
    return []; // 解析出错就不上报堆栈信息
  }
}

export function getStackObjList(error: Error): string[] {
  try {
    if (!isErrorInstance(error)) return [];
    const stackList: StackFrame[] = ErrorStackParser.parse(error);
    return stackList.map((item) => stringify(item) as string);
  } catch (e) {
    console.error('解析错误堆栈出错', e);
    return [];
  }
}
